export default "__VITE_ASSET__BQgYMGhQ__"